module.exports = __webpack_public_path__ + "static/media/Lines.0718fe32.svg";